import React from 'react';
import styles from './AboutUs2.module.css';

const AboutUs2 = ({home}) => {
  return (
    <section className={home ? styles.aboutUs2: styles.aboutUs3}>
      <div className={styles.columnRight}>
        <h1 className={styles.orangeTitle}>Our Mission</h1>
        <h1 className={styles.blackTitle}>Making the world a<br/>less lonely place</h1>
        <h2 className={styles.subtitle}>one match at a time</h2>
      </div>
      <div className={styles.columnLeft}>
        <h1 className={styles.orangeTitle}>Our Vision</h1>
        <h1 className={styles.blackTitle}>Redesign online dating</h1>
        <h2 className={styles.subtitle}>to include the human component</h2>
      </div>
    </section>
  );
};

export default AboutUs2;
